<template>
  <div>
    <tool-bar :title="title"></tool-bar>
    <loading :loading="loading"></loading>

    <error-alert-item
      :error-alert-event="errorAlertEvent"
      :network-error="networkError"
      @resetErrorAlertEvent="errorAlertEvent = false"
    ></error-alert-item>

    <refresh-item
      :show="showRefreshItem"
      @onRefresh="getInitialData"
    ></refresh-item>

    <date-picker-dialog
      select-date-title="Date of Application"
      :show-date-picker="showDatePicker"
      :default-selected-date="defaultSelectedDate"
      :max-allowed-date="currentDateAsYYYYMMDD"
      closeText="Clear"
      @closeClicked="clearSelectedDate"
      @dateSelected="doaSelected"
    ></date-picker-dialog>

    <activity-redirect-item
      :loan-tasks="tasks"
      :current-loan-task="currentTaskName"
      :is-loan-task="true"
      :redirect-activity="redirectActivity"
    ></activity-redirect-item>

    <div
      class="input_container"
      v-show="isFieldNeeded('doa') || isFieldNeeded('acknowledgement_number')"
    >
      <weex-text class="input_label">
        If applied for PAN and it's not generated yet <br />
        (Mandatory if non-agri income is ₹2.5 lakh or more)
      </weex-text>
      <div class="input_container" v-show="isFieldNeeded('doa')">
        <weex-text class="input_label">Date of Application</weex-text>
        <input
          ref="doa"
          v-model="doa"
          class="input_with_border_bottom"
          @focus="showDatePickerDialog"
        />
      </div>
      <div
        class="input_container"
        v-show="isFieldNeeded('acknowledgement_number')"
      >
        <weex-text class="input_label">Acknowledgement Number</weex-text>
        <input
          class="input_with_border_bottom"
          v-model="acknowledgementNumber"
          type="text"
        />
      </div>
    </div>

    <div
      class="input_container"
      v-show="
        isFieldNeeded('agricultural_income') ||
        isFieldNeeded('other_than_agricultural_income')
      "
    >
      <weex-text class="input_label">
        Please fill estimated total income <br />
        (including income of spouse, minor child etc. as per section 64 of
        Income-tax Act, 1961) <br />
        for the financial year in which the above transaction is held.
      </weex-text>
      <div
        class="input_container"
        v-show="isFieldNeeded('other_than_agricultural_income')"
      >
        <weex-text class="input_label">Agricultural income</weex-text>
        <input
          class="input_with_border_bottom"
          v-model="agriculturalIncome"
          v-on:keyup="checkIncome"
          type="number"
        />
      </div>
      <div
        class="input_container"
        v-show="isFieldNeeded('agricultural_income')"
      >
        <weex-text class="input_label"
          >Other than Agricultural income</weex-text
        >
        <input
          class="input_with_border_bottom"
          v-model="otherThanAgriculturalIncome"
          v-on:keyup="checkIncome"
          type="number"
        />
      </div>
    </div>

    <wxc-button
      text="Continue"
      class="horizontal_center margin-top-30"
      type="blue"
      @wxcButtonClicked="onContinueClicked"
    >
    </wxc-button>
  </div>
</template>

<script>
import ToolBar from "../../layout/ToolBar";
import Loading from "../../layout/Loading";
import ErrorAlertItem from "../../layout/ErrorAlertItem";
import ActivityRedirectItem from "../../layout/ActivityRedirectItem";
import EzUtils from "../../../utils/EzUtils";
import { DataTables } from "../../../utils/DataTables";
import { Activities } from "../../../utils/ActivityNavigator";
import DateUtils, { DateFormats } from "../../../utils/DateUtils";
import { MessageConstants } from "../../../utils/MessageConstantUtil";
import LoanTasksActivityNavigator from "../../../utils/LoanTasksActivityNavigator";
import DataSource from "../../../data/DataSource";
import LoanScopeDataHolder from "../../../data/model/LoanScopeDataHolder";
import AlertService from "../../core/alert/AlertService";
import DatePickerDialog from "../../dialogs/DatePickerDialog";
import WxcButton from "../../../../weex-ui/packages/wxc-button/index";
import RefreshItem from "../../layout/RefreshItem";
import DynamicFieldUtils, {
  FieldTypes,
} from "../../../utils/DynamicFieldUtils";

const INVALID_DATE = "Invalid date";

export default {
  name: "Form60DetailsActivity",
  components: {
    ActivityRedirectItem,
    ErrorAlertItem,
    Loading,
    ToolBar,
    DatePickerDialog,
    WxcButton,
    RefreshItem,
  },
  data: () => ({
    title: "Form 60 Details",
    loading: false,
    errorAlertEvent: false,
    networkError: {},
    showDatePicker: false,
    defaultSelectedDate: "2020-01-01",
    doa: "",
    acknowledgementNumber: "",
    agriculturalIncome: "",
    otherThanAgriculturalIncome: "",
    dynamicFields: null,
    rowId: -1,
    showRefreshItem: false,
  }),

  created: function () {
    this.dynamicFields = DynamicFieldUtils.getRequiredDynamicFieldsData();
    this.getInitialData();
  },

  methods: {
    showError(error) {
      this.loading = false;
      this.networkError = error;
      this.errorAlertEvent = true;
    },

    showToast(message) {
      AlertService.showToast(message);
    },

    showDatePickerDialog() {
      this.showDatePicker = true;
      this.$refs.doa.blur();
    },

    doaSelected(date) {
      this.showDatePicker = false;
      if (this.$refs && this.$refs.doa) {
        this.$refs.doa.blur();
      }
      this.doaSelectedWithDateFormat(date, DateFormats.YYYY_MM_DD);
    },

    doaSelectedWithDateFormat(date, dateFormat) {
      const formattedDOA = DateUtils.getFormatDateAsString(
        date,
        dateFormat,
        DateFormats.DD_MMMM_YYYY
      );
      const defaultSelectedDate = DateUtils.getFormatDateAsString(
        date,
        dateFormat,
        DateFormats.YYYY_MM_DD
      );
      if (
        formattedDOA &&
        defaultSelectedDate &&
        !EzUtils.areEqualString(INVALID_DATE, formattedDOA, true) &&
        !EzUtils.areEqualString(INVALID_DATE, defaultSelectedDate, true)
      ) {
        this.defaultSelectedDate = defaultSelectedDate;
        this.doa = formattedDOA;
      }
    },

    onContinueClicked() {
      if (this.checkForValidation()) {
        let payload = this.getPayLoad();
        this.saveFormSixtylDetails(payload);
      }
    },

    getPayLoad() {
      let payload = {
        pan_date_of_application: this.doa ? this.doa : "",
        pan_application_acknowledgement_number: this.acknowledgementNumber
          ? this.acknowledgementNumber
          : "",
        estimated_agricultural_income: this.agriculturalIncome
          ? this.agriculturalIncome
          : "",
        estimated_non_agricultural_income: this.otherThanAgriculturalIncome
          ? this.otherThanAgriculturalIncome
          : "",
      };
      return payload;
    },

    saveFormSixtylDetails(payload) {
      this.loading = true;
      if (EzUtils.isValidId(this.rowId)) {
        DataSource.updateDataTableEntry(
          DataTables.FORM_SIXTY,
          LoanScopeDataHolder.getLoanId(),
          payload
        ).then((res) => {
          if (res.errorOccurred) {
            this.showError(res.data);
          } else {
            this.getNextTask();
          }
        });
      } else {
        DataSource.addDataTableEntry(
          DataTables.FORM_SIXTY,
          LoanScopeDataHolder.getLoanId(),
          payload
        ).then((res) => {
          if (res.errorOccurred) {
            this.showError(res.data);
          } else {
            this.getNextTask();
          }
        });
      }
    },

    getNextTask() {
      LoanTasksActivityNavigator.getNextTask(this.tasks).then((res) => {
        this.loading = false;
        if (res.errorOccurred) {
          this.showError(res.data);
        }
      });
    },

    /**
     * Add validation
     */
    checkForValidation() {
      if (
        this.otherThanAgriculturalIncome > this.maxNonAgriculturalIncome()
      ) {
        if (!this.doa && this.isFieldNeeded("doa")) {
          this.showToast(MessageConstants.DATE_OF_APPLICATION_ERROR);
          return false;
        }

        if (!this.acknowledgementNumber && this.isFieldNeeded("acknowledgement_number")) {
          this.showToast(MessageConstants.ACKNOWLEDGEMENT_NUMBER_ERROR);
          return false;
        }
      }

      //Date of application cannot be in future.
      if (this.doa) {
        let isDateGreater = this.isDateGreaterThanTodayDate(this.doa);
        if (isDateGreater) {
          this.showToast(MessageConstants.FUTURE_DATE_OF_APPLICATION_ERROR);
          return false;
        }
      }

      if(!this.agriculturalIncome){
        this.showToast(MessageConstants.AGRI_INCOME_ERROR);
        return false;
      }
      return true;
    },

    getInitialData() {
      this.loading = true;
      DataSource.getDataTableInfo(
        DataTables.FORM_SIXTY,
        LoanScopeDataHolder.getLoanId()
      ).then((res) => {
        this.loading = false;
        if (res.errorOccurred) {
          this.showError(res.data);
          this.showRefreshItem = true;
        } else {
          if (EzUtils.isNotEmpty(res.data)) {
            const details = res.data[0];
            this.rowId = details.loan_id;
            this.convertArrayToDate(details.pan_date_of_application);
            this.acknowledgementNumber =
              details.pan_application_acknowledgement_number;
            this.agriculturalIncome = details.estimated_agricultural_income;
            this.otherThanAgriculturalIncome =
              details.estimated_non_agricultural_income;
          }
        }
      });
    },

    convertArrayToDate(dateArray) {
      if (dateArray) {
        const date = `${dateArray[0]}-${dateArray[1]}-${dateArray[2]}`;
        this.doaSelectedWithDateFormat(date, DateFormats.YYYY_MM_DD);
      }
    },

    clearSelectedDate() {
      this.showDatePicker = false;
      this.doa = "";
    },

    maxNonAgriculturalIncome() {
      //TODO fetch it from backend
      return 250000;
    },

    isDateGreaterThanTodayDate(date) {
      var ToDate = new Date();
      if (new Date(date).getTime() > ToDate.getTime()) {
        return true;
      }
      return false;
    },

    checkIncome() {
      if (this.agriculturalIncome && this.agriculturalIncome == 0) {
        this.agriculturalIncome = 0;
      }
      if (
        this.otherThanAgriculturalIncome &&
        this.otherThanAgriculturalIncome == 0
      ) {
        this.otherThanAgriculturalIncome = 0;
      }
    },

    isFieldNeeded(key) {
      return this.dynamicFields == null || this.dynamicFields[key] != null;
    },
  },

  computed: {
    currentDateAsYYYYMMDD() {
      return DateUtils.getCurrentTimeAsFormat(DateFormats.YYYY_MM_DD);
    },
    tasks() {
      return [Activities.FORM_SIXTY_DETAILS];
    },
    redirectActivity() {
      return Activities.LOAN_DETAILS;
    },
    currentTaskName() {
      return LoanScopeDataHolder.getCurrentLoanTask()
        ? LoanScopeDataHolder.getCurrentLoanTask().name
        : "";
    },
  },
};
</script>

<style scoped src="../../../assets/style/base.css"></style>


